import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const purchaseGoodsInTransitsFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      resettable
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
  ];
  return defaultFilter;
};
export default purchaseGoodsInTransitsFilterList;
